let NavList = [
  {
    text: "Home",
    Icon: "HomeIcon",
    children: [{ Name: "Home", Path: "Student", NewTab: false }],
  },
  //   {
  //     text: "Forms",
  //     Icon: "ChecklistIcon",
  //     children: [
  //       {
  //         Name: "Basic Info",
  //         Path: "Student/ViewBasicInfo/:id",
  //         NewTab: false,
  //       },
  //       {
  //         Name: "Public Reg Form",
  //         Path: "Public/RegistrationForm/Anonymous",
  //         NewTab: true,
  //       },
  //     ],
  //   },
];

export default NavList;
